/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { css } from "@emotion/core"

export const dropdownSubtextStyle = css`
  font-size: 12px;
  white-space: normal;
  color: #707070;
`
export const dropdownMenuItemStyle = css`
  height: 100px;
  padding: 20px !important;
  p {
    margin: 0;
  }
`
export const dropdownTextStyle = css`
  font-size: 16px;
  font-weight: 500;
`

export const dropdownButton = css`
  width: 100%;

  .anticon-chevron-down {
    font-size: 16px;
  }

  &:not(:disabled, [disabled]) {
    color: #1a1a1a;

    &:not(:hover) {
      border: 1px solid #e8e8e8;
    }

    &:hover {
      background-color: unset !important;
      color: unset !important;
    }

    &:focus {
      border-color: #00b14f !important;
      box-shadow: 0 0 0 2px rgba(2, 235, 35, 0.15);
    }
  }
`

export const dropdownEditButton = css`
  padding: 0 !important;
  width: 34px !important;
  height: 34px !important;
  border: 1px solid #e8e8e8;
`
